<template>
  <!-- 工单详情属性基础表格 -->
  <div>
    <XTable ref="table" :dataApi="dataApi" :columns="columns" :paging="false" :params="{batchCode:getWorkOrder.batchCode}" v-on="$listeners">
    </XTable>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props:{
    dataApi: Function,
    columns: Array,
    workOrderId: Number
  },
  data(){
    return {
    }
  },
  computed:{
     ...mapGetters(["getWorkOrder"]),
  },
  created(){
    
  },
  mounted(){
   
  },
  methods:{
    //获取列表数据
    loadTableData(){
      if(this.workOrder){
        this.$refs.table.searchList()
      }
    }
  }
}
</script>
<style lang="less" scoped>

</style>